


// import React, { useState, useEffect } from 'react';
// import './Project.css';
// import Navbar from '../Navbar/Navbar';
// import Footer from '../Footer/Footer';

// const Project = () => {
//   const [projects, setProjects] = useState([]);
//   const [filteredProjects, setFilteredProjects] = useState([]);

//   const [selectedCategory, setSelectedCategory] = useState('');
//   const [selectedCountry, setSelectedCountry] = useState('');

//   const [categories, setCategories] = useState([]);
//   const [countries, setCountries] = useState([]);

//   // Fetch Projects From API
//   useEffect(() => {
//     fetch( "https://infosightapi.emedha.in/api/projects")
//       .then((res) => res.json())
//       .then((data) => {
//         setProjects(data);
//         setFilteredProjects(data);

//         // Extract unique categories
//         const uniqueCategories = [
//           ...new Set(data.map((item) => item.category)),
//         ];
//         setCategories(uniqueCategories);

//         // Extract unique countries
//         const uniqueCountries = [
//           ...new Set(data.map((item) => item.country)),
//         ];
//         setCountries(uniqueCountries);
//       })
//       .catch((error) => console.error("Error fetching projects:", error));
//   }, []);

//   // Filter Projects on filter change
//   useEffect(() => {
//     let filtered = projects;

//     if (selectedCategory) {
//       filtered = filtered.filter(
//         (project) => project.category === selectedCategory
//       );
//     }

//     if (selectedCountry) {
//       filtered = filtered.filter(
//         (project) => project.country === selectedCountry
//       );
//     }

//     setFilteredProjects(filtered);
//   }, [selectedCategory, selectedCountry, projects]);

//   return (
//     <>
//       <Navbar />

//       <div className="project-container">
//         <div className="project-wrapper">
          
//           {/* Sidebar Filters */}
//           <aside className="project-sidebar">
//             <h2 className="sidebar-title">Filter Projects</h2>

//             {/* Category Filter */}
//             <div className="filter-group">
//               <label>Category</label>
//               <select
//                 value={selectedCategory}
//                 onChange={(e) => setSelectedCategory(e.target.value)}
//               >
//                 <option value="">All Categories</option>
//                 {categories.map((cat, index) => (
//                   <option key={index} value={cat}>
//                     {cat}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Country Filter */}
//             <div className="filter-group">
//               <label>Country</label>
//               <select
//                 value={selectedCountry}
//                 onChange={(e) => setSelectedCountry(e.target.value)}
//               >
//                 <option value="">All Countries</option>
//                 {countries.map((country, index) => (
//                   <option key={index} value={country}>
//                     {country}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </aside>

//           {/* Projects Display */}
//           <main className="project-main">
//             <h2 className="project-title">
//               Projects ({filteredProjects.length})
//             </h2>

//             <div className="project-grid">
//               {filteredProjects.map((project) => (
//                 <div key={project.id} className="project-card">
//                   <img
//                     src={project.image}
//                     alt={project.name}
//                     className="project-image"
//                   />
//                   <h3 className="project-name">{project.name}</h3>
//                   <p className="project-meta">{project.category}</p>
//                   <p className="project-meta">{project.country}</p>
//                 </div>
//               ))}

//               {filteredProjects.length === 0 && (
//                 <p className="no-projects">No projects found.</p>
//               )}
//             </div>
//           </main>
//         </div>
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default Project;


import React, { useState, useEffect } from 'react';
import './Project.css';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { FaArrowRight, FaMapMarkerAlt, FaTags, FaTasks } from 'react-icons/fa';

const Project = () => {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);

  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedCountry, setSelectedCountry] = useState('');

  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    fetch("https://infosightapi.emedha.in/api/projects")
      .then((res) => res.json())
      .then((data) => {
        setProjects(data);
        setFilteredProjects(data);
        setCategories([...new Set(data.map((item) => item.category))]);
        setCountries([...new Set(data.map((item) => item.country))]);
      })
      .catch((error) => console.error("Error fetching projects:", error));
  }, []);

  useEffect(() => {
    let filtered = projects;
    if (selectedCategory) filtered = filtered.filter((p) => p.category === selectedCategory);
    if (selectedCountry) filtered = filtered.filter((p) => p.country === selectedCountry);
    setFilteredProjects(filtered);
  }, [selectedCategory, selectedCountry, projects]);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getRelatedProjects = (current) => {
    return projects
      .filter((p) => p.category === current.category && p.id !== current.id)
      .slice(0, 3);
  };

  return (
    <>
      <Navbar />

      {selectedProject ? (
        /* --- PREMIUM DETAIL VIEW --- */
        <div className="project-detail-container fade-in">
          <div className="detail-hero" style={{ backgroundImage: `url(${selectedProject.image})` }}>
            <div className="detail-hero-overlay">
              <h1 className="detail-title">{selectedProject.name}</h1>
              <div className="breadcrumb">
                <span className="breadcrumb-link" onClick={() => window.location.href='/'}>Home</span>
                <span className="breadcrumb-sep">/</span>
                <span className="breadcrumb-link" onClick={() => setSelectedProject(null)}>Projects</span>
                <span className="breadcrumb-sep">/</span>
                <span className="breadcrumb-current">{selectedProject.name}</span>
              </div>
            </div>
          </div>

          <div className="detail-content-wrapper">
<div className="detail-split">
  {/* IMAGE FIRST */}
  <div className="detail-image-box">
    <img
      src={selectedProject.image}
      alt={selectedProject.name}
      className="detail-main-img"
    />
  </div>

  {/* PROJECT OVERVIEW SECOND */}
  <div className="detail-summary-card">
    <div className="accent-line"></div>
    <h3 className="summary-heading">Project Overview</h3>

  <div className="summary-grid">
  <div className="summary-item">
    <span className="summary-label">
      <FaMapMarkerAlt style={{ color: "#e40613", marginRight: 6 }} />
      Location
    </span>
    <span className="summary-value">{selectedProject.country}</span>
  </div>

  <div className="summary-item">
    <span className="summary-label">
      <FaTags style={{ color: "#e40613", marginRight: 6 }} />
      Category
    </span>
    <span className="summary-value">{selectedProject.category}</span>
  </div>

  <div className="summary-item full-width">
    <span className="summary-label">
      <FaTasks style={{ color: "#e40613", marginRight: 6 }} />
      Scope of Work
    </span>
    <span className="summary-value">
      {selectedProject.scope_of_work}
    </span>
  </div>
</div>


    {selectedProject.description && (
      <div className="detail-description">
        <p>{selectedProject.description}</p>
      </div>
    )}
  </div>
</div>


            <div className="related-section">
              <div className="section-header">
                <h3 className="section-title">Related Projects</h3>
                <div className="section-line"></div>
              </div>
              <div className="related-grid">
                {getRelatedProjects(selectedProject).map((related) => (
                  <div key={related.id} className="related-card" onClick={() => handleProjectClick(related)}>
                    <div className="related-img-wrapper">
                      <img src={related.image} alt={related.name} />
                      <div className="related-overlay"><FaArrowRight /></div>
                    </div>
                    <div className="related-info">
                      <h4>{related.name}</h4>
                      <span>{related.category}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        /* --- LIST VIEW --- */
        <div className="project-container fade-in">
          <div className="project-wrapper">
            <aside className="project-sidebar">
              <h2 className="sidebar-title">Filter Projects</h2>
              <div className="filter-group">
                <label>Category</label>
                <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                  <option value="">All Categories</option>
                  {categories.map((cat, i) => <option key={i} value={cat}>{cat}</option>)}
                </select>
              </div>
              <div className="filter-group">
                <label>Country</label>
                <select value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)}>
                  <option value="">All Countries</option>
                  {countries.map((c, i) => <option key={i} value={c}>{c}</option>)}
                </select>
              </div>
            </aside>

            <main className="project-main">
              {/* UPDATED TITLE WITH COUNT */}
              <h2 className="project-title">
               Projects <span className="project-count">({filteredProjects.length})</span>
              </h2>

              <div className="project-grid">
                {filteredProjects.map((project) => (
                  <div key={project.id} className="project-card" onClick={() => handleProjectClick(project)}>
                    <div className="card-img-container">
                       <img src={project.image} alt={project.name} className="project-image" />
                       <div className="card-overlay">View Details</div>
                    </div>
                    <div className="card-content">
                        <h3 className="project-name">{project.name}</h3>
                        <p className="project-meta">{project.category} | {project.country}</p>
                    </div>
                  </div>
                ))}
              </div>
              {filteredProjects.length === 0 && <p className="no-projects">No projects found.</p>}
            </main>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Project;